import { render, staticRenderFns } from "./PageChooseZone.vue?vue&type=template&id=3bc77652&scoped=true&"
import script from "./PageChooseZone.vue?vue&type=script&lang=ts&"
export * from "./PageChooseZone.vue?vue&type=script&lang=ts&"
import style0 from "./PageChooseZone.vue?vue&type=style&index=0&id=3bc77652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc77652",
  null
  
)

export default component.exports